

<app-modal-header
  (close)="close()"
  [highlighted]="true">
  <span slot="breadcrumb">
    <ng-container *ngIf="operation === Operation.CREATE">
      {{"admin.org-member-modal.create.title" | translate }}
    </ng-container>
    <ng-container *ngIf="operation === Operation.UPDATE">
      {{"admin.org-member-modal.update.title" | translate }}
    </ng-container>
  </span>

  <ng-container slot="underContent">

    <div class="flex mt-3">
      <app-image-input
        [imagePreview]="profilePicturePreview"
        (imageChanged)="pictureChanged($event)"
        style="width: 6.5rem;">
      </app-image-input>
    
      <div class="flex-1 pl-2 grid">
      
        <div class="col-6">
          <input id="name" placeholder="{{'admin.org-member-modal.name' | translate}}" [formControl]="form.controls.name" type="text" pInputText class="w-full">
        </div>
        
        <div class="col-6">
          <input id="surname" placeholder="{{'admin.org-member-modal.surname' | translate}}" [formControl]="form.controls.surname" type="text" pInputText class="w-full">
        </div>
      
        <div class="col-12">
          <input id="email" placeholder="{{'admin.org-member-modal.email' | translate}}" [formControl]="form.controls.email" pInputText class="w-full">
        </div>
      </div>
    </div>

  </ng-container>
</app-modal-header>

<div [formGroup]="form" class="modal-body">

  <div class="flex flex-column">
    
    <div class="">
      <label for="lecturer" class="surface-border border-1 p-3 border-round-top flex align-items-center gap-3 cursor-pointer">
          <p-checkbox inputId="lecturer" [formControl]="rolesFC" [value]="RoleType.LECTURER"></p-checkbox>
          <div>
            <div class="font-medium mb-1">{{"RoleType.LECTURER" | translate }}</div>
            <span class="text-sm">
              {{"admin.org-member-modal.role-description.lecturer" | translate }}
            </span>
          </div>
      </label>
      <label *ngIf="showCoordinatorOption$ | async" for="coordinator" class="surface-border border-1 border-top-none p-3 flex align-items-center gap-3 cursor-pointer">
        <p-checkbox inputId="coordinator" [formControl]="rolesFC" [value]="RoleType.COORDINATOR"></p-checkbox>
        <div>
            <div class="font-medium mb-1">{{"RoleType.COORDINATOR" | translate }}</div>
            <span class="text-sm" >
              {{"admin.org-member-modal.role-description.coordinator" | translate }}
            </span>
          </div>
      </label>
      <label *ngIf="showAdminOption$ | async" for="admin" class="surface-border border-1 border-top-none p-3 border-round-bottom flex align-items-center gap-3 cursor-pointer">
        <p-checkbox inputId="admin" [formControl]="rolesFC" [value]="RoleType.ORG_ADMIN"></p-checkbox>
        <div>
            <div class="font-medium mb-1">{{"RoleType.ORG_ADMIN" | translate }}</div>
            <span class="text-sm" >
              {{"admin.org-member-modal.role-description.org-admin" | translate }}
            </span>
          </div>
      </label>
    </div>

    <!--
      TODO zatim budou nastavene custom form settings pro LECTURERs, ale funguje to pro kazde role 
      az bude potreba, udelat collapsable sekci pro kazdou roli
    -->
    
    @if (form.value.roles?.includes(RoleType.LECTURER)) {
      <section>
        <ng-container *ngTemplateOutlet="dividerEl"></ng-container>
  
        <div (click)="lecturerSectionCollapsed = !lecturerSectionCollapsed" class="flex justify-content-between cursor-pointer py-2">
          <p class="m-0 font-bold">
            {{ 'admin.org-member-modal.lecturer-section' | translate }}
          </p>
  
          <i class="pi {{ lecturerSectionCollapsed ? 'pi-chevron-up' : 'pi-chevron-down' }}"></i>
        </div>
  
        <div [@collapse]="lecturerSectionCollapsed">
          
          <div class="mt-3"></div>

          @for (settingWithData of customMemberFormSettingsWithData; track settingWithData) {
            @if (form.controls.orgMemberData.get(settingWithData.uuid); as control) {
              <div class="">
                <app-custom-org-member-input [FC]="$any(control)" [settingWithData]="settingWithData"></app-custom-org-member-input>
              </div>
            }
          }

          <div class="field">
            <p class="m-0 text-xs mb-1">
              {{'admin.org-member-modal.nickname' | translate}}
            </p>
            <input formControlName="nickname" type="text" pInputText class="w-full">
          </div>
      
          <div class="field">
            <p class="m-0 text-xs mb-1">
              {{'admin.org-member-modal.biography' | translate}}
            </p>
            <p-editor #ed formControlName="bio" [modules]="{clipboard:{matchVisual:false}}" [style]="{'min-height':'5rem'}">
              <ng-template pTemplate="header">
                <span class="ql-formats">
                  <button type="button" class="ql-bold" aria-label="Bold"></button>
                  <button type="button" class="ql-italic" aria-label="Italic"></button>
                  <button type="button" class="ql-underline" aria-label="Underline"></button>
                </span>
                <span class="ql-formats">
                  <button class="ql-list" value="ordered"></button>
                  <button class="ql-list" value="bullet"></button>
                </span>
                <span class="ql-formats">
                  <button aria-label="Link" class="ql-link"></button>
                </span>
                <span class="ql-formats">
                  <button (click)="ed.getQuill().removeFormat(ed.getQuill().getSelection().index,ed.getQuill().getSelection().length)" class="cust-clear" title="{{ 'admin.wysiwyg.clearFormating' | translate }}"><i class="pi pi-eraser text-lg font-medium text-color-secondary" style="margin-top: 0.102rem;"></i></button>
                </span>
              </ng-template>
            </p-editor>
          </div>

          <div *ngIf="lecturerHourRateFG" class="field">
            <p class="m-0 text-xs -mb-1">
              {{'admin.org-member-modal.default-hourrate' | translate}}
            </p>
            <app-hour-rate-fg [fg]="lecturerHourRateFG"></app-hour-rate-fg>
          </div>
      
          <div class="field">
            <p class="m-0 text-xs mb-1">
              {{'admin.org-member-modal.lecturer-note' | translate}}
            </p>
            <input formControlName="lecturerNote" type="text" pInputText class="w-full">
          </div>

          <div class="field">
            <p class="m-0 text-xs mb-1">
              {{'admin.location-modal.calendars' | translate}}
            </p>
            <app-google-calendar-sync [disabled]="!userId" disabledTooltip="admin.org-member-modal.calendar.disabled.tooltip" [lecturerUserId]="userId" />
          </div>
          
        </div>
      </section>

      <section>
        <ng-container *ngTemplateOutlet="dividerEl"></ng-container>

        <div (click)="lecturerSessionsCollapsed = !lecturerSessionsCollapsed" class="flex justify-content-between cursor-pointer py-2">
          <p class="m-0 font-bold">
            {{ 'admin.org-member-modal.lecturer-sessions' | translate }}
          </p>

          <i class="pi {{ lecturerSessionsCollapsed ? 'pi-chevron-up' : 'pi-chevron-down' }}"></i>
        </div>

        <div [@collapse]="lecturerSessionsCollapsed">

          <div class="mt-3"></div>

          @for (session of orgLecturerSessions; track session) {
            <div class="field surface-border border-1 p-3 border-round flex align-items-start flex flex-column gap-2">
              <div class="flex">
                <span class="text-color font-bold cursor-pointer hover:underline" (click)="onShopItemTitle(session)">{{ session.shopItemTitle }}</span>
              </div>

              <div class="details-block-wrap flex">
                <span class="detail-block text-sm">
                  <span class="cursor-pointer hover:underline" (click)="onSession(session)">
                    {{ 'admin.org-member-modal.nth-session' | translate:{ nth: session.index + 1 } }}
                  </span>
                </span>

                <span class="detail-block text-sm align-items-center">
                  <span>
                    <span>{{ session.startAt | localizedDate:'d. M. H:mm' }}</span>
                    @if (session.differentEndDay) {
                      <span> - {{ session.endAt | localizedDate:'H:mm d. M. yyyy' }}</span>
                    } @else {
                      <span> - {{ session.endAt | localizedDate:'H:mm' }}</span>
                    }
                  </span>
                </span>

                <span class="detail-block text-sm flex align-self-center" style="color: var({{ session.stateColor }})">{{ ('SessionState.' + session.state) | translate }}</span>
              </div>
              <div class="details-block-wrap flex">
                @if (session.title) {
                  <span class="detail-block text-color text-sm">{{ session.title }}</span>
                }
              </div>
            </div>
          }

          @if (showFetchNextSessions) {
            <div class="flex justify-content-center">
              <button
                (click)="onLoadNextSessions()"
                [loading]="fetchingNextOrgLecturerSessions"
                [disabled]="fetchingNextOrgLecturerSessions"
                pButton
                label="{{'admin.org-member-modal.load-next-sessions' | translate}}"
                class="p-button-sm border-bluegray-200 bg-bluegray-200">
              </button>
            </div>
          }

        </div>
      </section>
    }


    <!-- admin notes -->
    <div *ngIf="hasAnyNotes" class="">
      <ng-container *ngTemplateOutlet="dividerEl"></ng-container>

      <p class="m-0 font-bold">
        {{ 'admin.org-member-modal.admin-notes-label' | translate }}
      </p>

      <ng-container *ngFor="let role of user?.roles ?? []">
        <ng-container *ngIf="role.adminNotes.length">
          <label>{{ "RoleType."+role.type | translate }}</label>
          <ng-container *ngFor="let note of role.adminNotes">
            <p class="m-0">
              {{ note.datetime | localizedDate:'short' }}: {{ note.text }}
            </p>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

</div>

<div class="modal-footer">
  <div *ngIf="CANNOT_UPDATE_EMAIL_ALREADY_EXIST">
    <p-message severity="danger" text="{{'admin.message.CANNOT_UPDATE_EMAIL_ALREADY_EXIST' | translate}}"></p-message>
  </div>

  <div class="flex justify-content-between align-items-center flex-1">

    <div class="flex column-gap-2">
      @if (sendInvitationFC) {
        <div class="flex gap-2 align-items-start">
          <p-inputSwitch inputId="inviteUser" [formControl]="sendInvitationFC"></p-inputSwitch>
          <label for="inviteUser">{{"admin.org-member-modal.send-invitation" | translate}}</label>
        </div>
      }

      @if (user?.registered === false && user?.email) {
        <button
          (click)="onInvite()"
          pButton
          icon="pi pi-send"
          iconPos="left"
          label="{{'admin.org-member-modal.invite' | translate}}"
          [class.loading-box]="!!(orgUsersState?.invitingUnregistered$ | async)?.includes(user!.id)"
          class="p-button-sm p-button-outlined p-button-plain flex-none ml-0">
        </button>
      }
    </div>

    
    <div class="flex column-gap-2">


      <button
        (click)="onSubmit()"
        [loading]="sending"
        [disabled]="sending"
        pButton
        label="{{'admin.org-member-modal.save' | translate}}"
        class="p-button-sm">
      </button>
  
      @if (operation === Operation.CREATE) {
        <button
          (click)="onSubmit(true)"
          [loading]="sending"
          [disabled]="sending"
          pButton
          label="{{'admin.org-member-modal.create-add-next' | translate}}"
          class="p-button-sm">
        </button>
      }
    </div>


    
  </div>

</div>



<ng-template #dividerEl>
  <div class="border-top-1 surface-border compensate-modal-body-x-padding my-3"></div>
</ng-template>